module.exports = __webpack_public_path__ + "static/media/logo.2d2207c9.png";